import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconMicrophoneMute = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M9.75777 9.2737C9.37963 9.84108 8.7335 10.215 7.99997 10.215C6.83455 10.215 5.88979 9.27125 5.88979 8.10713V5.75736L2.16367 2.36997C1.95934 2.18422 1.94428 1.868 2.13003 1.66367C2.31579 1.45934 2.63201 1.44428 2.83634 1.63003L5.88979 4.4059V3.10782C5.88979 1.94371 6.83455 1 7.99997 1C9.16538 1 10.1101 1.9437 10.1101 3.10782V8.10713C10.1101 8.15138 10.1088 8.19531 10.1061 8.23889L10.9105 8.97021C10.9962 8.67703 11.0423 8.36584 11.0423 8.04342V6.89518C11.0423 6.61935 11.2567 6.39574 11.5212 6.39574C11.7856 6.39574 12 6.61935 12 6.89518V8.04342C12 8.62157 11.8873 9.17226 11.6834 9.67286L13.8363 11.63C14.0407 11.8158 14.0557 12.132 13.87 12.3363C13.6842 12.5407 13.368 12.5557 13.1637 12.37L11.1835 10.5698C10.5437 11.4456 9.57924 12.0495 8.47737 12.1862V14.0011H9.59239C9.85684 14.0011 10.0712 14.2247 10.0712 14.5006C10.0712 14.7764 9.85684 15 9.59239 15H6.4082C6.14374 15 5.92936 14.7764 5.92936 14.5006C5.92936 14.2247 6.14374 14.0011 6.4082 14.0011H7.51971V12.1858C5.53702 11.9383 4 10.1781 4 8.04342V6.89518C4 6.61935 4.21438 6.39574 4.47883 6.39574C4.74329 6.39574 4.95767 6.61935 4.95767 6.89518V8.04342C4.95767 9.79597 6.31977 11.2167 8 11.2167C9.01066 11.2167 9.90621 10.7027 10.4595 9.91162L9.75777 9.2737ZM9.00149 8.58618L6.88979 6.66645V8.10713C6.88979 8.71958 7.38683 9.21607 7.99997 9.21607C8.44133 9.21607 8.82254 8.95879 9.00149 8.58618ZM6.88979 5.31499L9.11014 7.33349V3.10782C9.11014 2.49537 8.6131 1.99889 7.99997 1.99889C7.38683 1.99889 6.88979 2.49537 6.88979 3.10782V5.31499Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
